function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthpow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M0 0L0 64L31 64L12 36L32 45.5733L51 36L33 64L64 64L64 0L33 0L51 33L32 42.0833L20 39L12 32L12 31C19.1552 24.3944 27.6438 9.2198 31 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1ddf3",
      stroke: "none"
    },
    d: "M31 0L20 16L24 18L22 20L22 21L27 26L13 31L25 37L24 39C30.2667 43.0761 33.6686 42.8177 40 39L39 34L40 34C43.1119 37.9309 47.3435 34.9033 51 33C49.8486 27.0458 46.5183 20.518 40 20L40 16L45 18L33 0L31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8898e2",
      stroke: "none"
    },
    d: "M19 16L13 31L27 26L22 21L22 20L24 18L19 16M40 16L40 20L45 19L40 16M30 22L29 25L34 26L30 22M34 27L36 29L34 27M41 27L41 33L42 33L41 27M36 30L37 31L36 30M12 31L13 32L12 31M25 32L26 33L25 32M39 34C39.5807 37.4901 40.4398 38.5474 44 38L44 37L39 34M20 35L20 39L25 38L25 37L20 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0101ff",
      stroke: "none"
    },
    d: "M12 36L13 37L12 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#677ff1",
      stroke: "none"
    },
    d: "M13 36L31 64L32 64L31.3966 47.3904L13 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1ddf3",
      stroke: "none"
    },
    d: "M50 36L32.6034 47.3897L32 64L33 64C37.1997 57.049 50.6634 43.9878 50 36z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthpow);
export default __webpack_public_path__ + "static/media/ethpow.bcd11d824f528d0bddfd7996263e6019.svg";
export { ForwardRef as ReactComponent };